var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "FAQDetail", "data-role": "page" } },
    [
      _c(
        "div",
        {
          staticClass: "FAQDetail-content",
          attrs: { "data-position": "fixed" }
        },
        [
          _c(
            "div",
            {
              staticClass: "detailWrap",
              staticStyle: { "margin-bottom": "10px" }
            },
            [
              _c("div", { staticClass: "detail-h" }, [
                _c("span", { staticClass: "cgy-tag" }, [
                  _vm._v(_vm._s(_vm.chn_tag(_vm.FAQDetail.qaType)))
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v(_vm._s(_vm.FAQDetail.qaTitle))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-c" }, [
                _c("div", { staticClass: "txtContent" }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.FAQDetail.qaFeedback) }
                  })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "article_date" }, [
                  _vm._v(_vm._s(_vm.FAQDetail.qaDate))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-extra" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.SetRecommend(_vm.qa_id, _vm.FAQDetail.is_push)
                      }
                    }
                  },
                  [
                    _c("i", {
                      class: [
                        _vm.FAQDetail.is_push ? "icon-smile-full active" : "",
                        "icon-smile"
                      ]
                    }),
                    _vm._v(_vm._s(_vm.FAQDetail.push_count))
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.SetFavorites(_vm.qa_id, _vm.FAQDetail.is_keep)
                      }
                    }
                  },
                  [
                    _c("i", {
                      class: [
                        _vm.FAQDetail.is_keep
                          ? "icon-bookmark-full active"
                          : "icon-bookmark",
                        "bookmarkIcon"
                      ]
                    }),
                    _vm._v("收藏")
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm._m(0)
        ]
      ),
      _vm._v(" "),
      _c("favoritesToast", {
        attrs: {
          show: _vm.toastControl.show,
          full: _vm.toastControl.full,
          content: _vm.toastControl.content,
          showTime: _vm.toastControl.showTime
        },
        on: {
          close: function($event) {
            _vm.toastControl.show = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "detailWrap articleWrap questionnaire",
        staticStyle: { "margin-bottom": "60px" }
      },
      [
        _c("div", { staticClass: "detail-c" }, [
          _c("div", { staticClass: "questionnaire" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://docs.google.com/forms/d/e/1FAIpQLSetKmRasOJyXyx4XNOt8g_bFeUpytB5dTVdzRnPkAhAN_Ezzg/viewform"
                }
              },
              [
                _c("div", { staticClass: "img" }),
                _vm._v(" "),
                _c("div", { staticClass: "txt" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("想看什麼快來許願吧！")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "content" }, [
                    _vm._v("不管你想看甚麼,我們都幫你準備。")
                  ])
                ])
              ]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-166e79a7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-166e79a7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQDetail.vue
// module id = null
// module chunks = 